const SvgCloseIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    fill="none"
    {...props}
  >
    <path
      fill="#333"
      fillRule="evenodd"
      d="M.498.998a1.417 1.417 0 0 1 2.004 0L10 8.496 17.498.998a1.417 1.417 0 1 1 2.004 2.004L12.003 10.5l7.499 7.498a1.417 1.417 0 0 1-2.004 2.004L10 12.503l-7.498 7.499a1.417 1.417 0 1 1-2.004-2.004L7.997 10.5.498 3.002a1.417 1.417 0 0 1 0-2.004"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCloseIcon;
